const initialState = {
  email: ''
};

const ForgotPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default ForgotPasswordReducer;



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/ForgotPasswordReducer.js
 **/